import { appRoutes } from '@/routes';

const routes = appRoutes();

// Walks through the team-wide analytics surfaces an admin actually lands on
// today: Department Dashboard (the default landing page) and its deep-dive
// pages (Timeline, Screenshots, App Usage).
export const productivityDataTourSteps = [
  {
    id: 'sidebar-department-dashboard',
    path: routes.teamDashboard,
    // The sidebar <li> is just a hook id — its visible pill is the
    // reactstrap <NavLink class="nav-link"> child, so the highlight must
    // target that directly (an outset shadow on the <li> gets clipped by
    // the scrollable nav list's overflow-x, and an inset shadow on the <li>
    // paints behind the opaque child and never shows).
    target: '#department-dashboard .nav-link',
    content:
      'Department Dashboard is your home base — you can always get back here from the sidebar.',
    placement: 'right',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '8px',
      padding: '8px',
    },
  },
  {
    id: 'department-dashboard-metrics',
    path: routes.teamDashboard,
    target: '[data-tour="department-dashboard-metrics"]',
    content:
      "Overall Productivity and Key Highlights give you an instant read on your team's day — productivity score, active/idle time, attendance, and focus time at a glance.",
    placement: 'bottom',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '12px',
      padding: '8px',
    },
  },
  {
    id: 'productivity-over-time',
    path: routes.teamDashboard,
    target: '[data-tour="productivity-over-time"]',
    content:
      "Productivity Over Time charts the team's score against the team average throughout the day, so you can spot when things pick up or drop off.",
    placement: 'bottom',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '12px',
      padding: '8px',
    },
  },
  {
    id: 'ai-insights',
    path: routes.teamDashboard,
    target: '[data-tour="ai-insights"]',
    content:
      'Insights surfaces what actually needs your attention — trends, top performers, and members who might need a check-in — without you having to dig for it.',
    placement: 'left',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '12px',
      padding: '8px',
    },
  },
  {
    id: 'team-performance',
    path: routes.teamDashboard,
    target: '[data-tour="team-performance"]',
    content:
      'Team Performance breaks it down by person — productivity score, active/idle/focus time, attendance, and a trend sparkline for each employee.',
    placement: 'top',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '12px',
      padding: '8px',
    },
  },
  {
    id: 'timeline-sessions',
    path: routes.timeline,
    target: '[data-tour="timeline-sessions"]',
    content:
      'Timeline breaks every day into individual sessions with exact start/end times, duration, idle time, and activity %. Use the Export button to download the data as CSV.',
    placement: 'bottom',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '8px',
      padding: '6px',
    },
  },
  {
    id: 'screenshots-gallery',
    path: routes.screenshots,
    target: '[data-tour="screenshots-gallery"]',
    content:
      'Screenshots captures periodic snapshots during active sessions, organised by day. Click any thumbnail to open the full-screen viewer with timestamps.',
    placement: 'bottom',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '8px',
      padding: '6px',
    },
  },
  {
    id: 'app-usage-breakdown',
    path: routes.appUsage,
    target: '[data-tour="app-usage-breakdown"]',
    content:
      'App Usage drills into every session and shows exactly which apps were open, for how long, and what percentage of the session they consumed.',
    placement: 'bottom',
    highlight: {
      boxShadow: 'inset 0 0 0 2px #3363f5',
      borderRadius: '8px',
      padding: '6px',
    },
  },
];
